<app-skill-builder-select-list
	[mainTitle]="page.title"
	[subTitle]="page.subTitle"
	[options]="options"
	[custom]="custom"
	[change]="onChange.bind(this)"
	[next]="next"
>
</app-skill-builder-select-list>
